import List from './List'
import Detail from './Detail'
import TextField from './TextField'
export default {
  install(Vue) {
    Vue.component('CrudList', List)
    Vue.component('CrudDetail', Detail)
    Vue.component('CTextField', TextField)
  },
}
